import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-arthauptgrp-list-view',
  imports: [],
  templateUrl: './arthauptgrp.list-view.html',
  styleUrls: ['./arthauptgrp.list-view.css'],
})
export class ArthauptgrpListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
